import React from 'react'

import LgyField from 'app/components/util/lgy-field/LgyField'
import { LgySubsection } from 'app/components/util/lgy-section/LgySection'

export const PersonalInformation = ({ user }) => {
  const nameFormatted = user.firstName.toUpperCase() + ' ' + (user.middleName && user.middleName !== 'NOT_FOUND' ? user.middleName.toUpperCase() + ' ' : '')
    + user.lastName.toUpperCase() + (user.suffixName ? ' ' + user.suffixName.toUpperCase() : '')

  const tooltipMessage =
    <div role='dialog' aria-describedby="tooltipMessageDesc">
      <span id="tooltipMessageDesc">Some of your personal information comes from your sign-on partner. Click&nbsp;</span>
      <a className='usa-external_link' href='https://access.va.gov/accessva/about#updatecred'>here</a><span>&nbsp;for instructions on how to change it.</span>
    </div>

  return <LgySubsection header='Personal Information' tooltip={tooltipMessage}>
    <LgyField label='Name' value={nameFormatted} />
    <LgyField label='SSN' value={user.ssn ? `***-**-${user.ssn}` : ''} />
  </LgySubsection>
}

export default PersonalInformation
